import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Download, Loader } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

export interface ActionMenuItemProps {
  tooltipMessage: string;
  flashTooltip?: boolean;
  loading?: boolean;
  startIcon?: ReactNode;
  onClick?: () => void;
}

const ActionMenuItem: FC<PropsWithChildren<ActionMenuItemProps>> = ({
  loading = false,
  onClick,
  startIcon = <Download />,
  children,
}) => {
  return (
    <DropdownMenuItem
      onClick={onClick}
      className="rounded-lg mx-0 my-px px-3 py-2 bg-transparent text-foreground border-none min-h-0 cursor-pointer hover:bg-accent"
    >
      {loading && <Loader className="mr-2 h-4 w-4 animate-spin text-primary" />}
      {!loading && (
        <div className="flex items-center justify-center mr-2 text-muted-foreground [&>svg]:text-[1.1rem]">
          {startIcon}
        </div>
      )}
      <div className="text-foreground text-sm font-medium">{children}</div>
    </DropdownMenuItem>
  );
};

export default ActionMenuItem;
